//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  async asyncData ({ app, req, $redirect, route, store, $sentry, error }) {
    // const path = route.fullPath.replace(`/${app.$i18n.locale}/`, '')
    const locale = (app.i18n || app.$i18n).locale || 'en'
    const path = route.fullPath.replace(new RegExp(`^/${locale}/`), '/')
    const query = path.includes('?') ? '?' + path.split('?').slice(1).join('?') : ''

    try {
      const data = await store.dispatch('url/RESOLVE', path.split('?')[0])
      const target = '/' + data.path + query

      if (data.resolved) {
        if (target !== path) {
          const statusCode = (data.rewrite && data.rewrite.options === 'RP') ? 301 : 302
          $redirect(target, statusCode)
        }
      }
      return {
        resolverResponse: data
      }
    } catch (error) {
      $sentry.captureException(error)
    }
    
    return {}
  },
  computed: {
    component () {
      try {
        if (this.resolverResponse.cms && this.resolverResponse.cms.custom_theme) {
          return () => import(`@/templates/${this.resolverResponse.cms.custom_theme}.vue`)
        } else if (this.resolverResponse.product && ['case'].includes(this.resolverResponse.sku_prefix)) {
          return () => import('@/templates/sungod18/product.vue')
        } else if (this.resolverResponse.product && this.resolverResponse.rewrite.product_id) {
          return () => import('@/templates/sungod18/product-dynamic.vue')
        }
      } catch (error) {
        this.$sentry.captureException(error)
        return false
      }
      return false
    },
    componentProps () {
      if (this.resolverResponse.cms) return this.resolverResponse.cms
      if (this.resolverResponse.product) return { ...this.resolverResponse.rewrite, skuPrefix: this.resolverResponse.sku_prefix }
      return {}
    }
  }
}
